import React, { Component } from 'react';
import firebase from 'firebase';
import { Grid, Row, Col, ListGroup, ListGroupItem, Badge, ButtonToolbar, Button } from 'react-bootstrap';
import Loading from '../../components/Loading';

type IState = {
  rooms: Object,
  modalRoom: Object,
  loading: boolean,
}

class Superadmin extends Component {

  constructor() {
    super();

    this.state = {
      rooms: {},
      modalRoom: {},
      loading: true,
    };
  }

  state: IState;

  componentDidMount() {
    firebase.database()
    .ref('room')
    .on('value', (snapshot) => {
      this.setState({
        rooms: snapshot.val() || {},
        loading: false,
      });
    });
  }

  handleSelect(key: string) {
    this.setState({
      selectedKey: key,
    });
  }
/*
  handleSave(item: Object) {
    const { lessons, lessonIndex } = this.state;
    const lessonKey = Object.keys(lessons)[lessonIndex];

    const room = item.room;

    const updates = {
      [`room/${room}`]: true,
    };

    firebase.database().ref().update(updates);

    this.setState({
      modal: null,
    });

    notify.show(`Phrases were updated!`, 'success', 3000);
  }

  handleSelect(key: string) {
    const { items } = this.state;
    this.setState({
      modal: { key, ...items[key] },
    });
  }*/

  render() {
    const { rooms, loading, selectedKey } = this.state;

    const sortedRoomsInArray = Object.keys(rooms).sort((a, b) => a.name < b.name ? -1 : 1).map(key => rooms[key]);

    return (
      <Grid>
        <Row style={{ marginBottom: '30px' }}>
          <Col xs={12}>
            <h1>Rooms</h1>
          </Col>
        </Row>
        <Row style={{ marginBottom: '30px' }}>
          <Col xs={12}>
            <div style={{ float: 'right' }}>
              <Badge bsStyle="default">{sortedRoomsInArray.length} rooms</Badge>
            </div>
            <ButtonToolbar>
              <Button bsStyle="success" onClick={(e) => this.setState({ modal: {} })}>Add Room</Button>
            </ButtonToolbar>
          </Col>
        </Row>
        {
          loading 
            ? <Loading />
            : (
              <div>
                <ListGroup>
                {
                  Object.keys(rooms).map((key) => (
                    <ListGroupItem key={key} header={key.toUpperCase()} onClick={(e) => this.handleSelect(key)}>
                      <div>Ahoj</div>
                    </ListGroupItem>
                  ))
                }
                </ListGroup>
              </div>
            )
        }
      </Grid>
    );
  }
}

export default Superadmin;



// WEBPACK FOOTER //
// ./src/pages/Superadmin/index.js